@if (viewed()) {
  <span class="eventq-alarm-indicator eventq-alarm-indicator--viewed" aria-hidden="true"></span>
} @else {
  <span class="eventq-alarm-indicator eventq-alarm-indicator--unviewed" aria-hidden="true"></span>
}
